module.exports = __webpack_public_path__ + "static/SW2-d1299d2e03b9d43755b33f710fb85831.jpg";